<div class="host-create-house">
  <nz-alert nzShowIcon [nzMessage]="'house.create_house_info' | translate"></nz-alert>

  <div class="v4-layout-form v4-layout-form-vertical mt-9" [formGroup]="nameForm">
    <div class="v4-layout-field" formArrayName="listOfName">
      <div class="v4-layout-field-label">
        {{ "word.name" | translate }}
        <!-- Name -->
      </div>
      <div class="v4-layout-field-control">
        <ng-container *ngFor="let name of listOfName.controls; let i = index">
          <div class="mb-3 flex flex-row items-center justify-between">
            <host-input-with-error
              class="flex-1"
              [showError]="repeatedNames.has(i)"
              [errorText]="'errorText.house_already_exist' | translate"
            >
              <input
                [formControlName]="i"
                (ngModelChange)="onNameChange($event, i)"
                type="text"
                nz-input
                nzSize="large"
                [placeholder]="'placeholder.house_name' | translate"
              />
            </host-input-with-error>
            <img
              *ngIf="listOfName.length > 1"
              src="/assets/house/delete_circle.png"
              class="ml-3 w-4 h-4 rounded-full"
              (click)="onNameDelete(i)"
            />
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- <div class="hc-container">
    <div class="titles">
      <div class="title" nz-row *ngFor="let item of titleList; index as i">
        <div nz-col [nzSpan]="3" class="index" *ngIf="titleList.length > 1">{{ item.index }}:</div>
        <div *ngIf="titleList.length === 1" nz-col [nzSpan]="3" style="text-align: right"></div>
        <div nz-col [nzSpan]="17">
          <host-input-with-error
            [showError]="
              (checking && titleList.length === 1 && (!titleList[0].text || titleList[0].text === '')) || item.error
            "
            errorText="{{
              (item.error ? 'errorText.house_already_exist' : 'errorText.house_name_required') | translate
            }}
            "
          >
            <input
              type="text"
              class="input-title"
              nz-input
              [ngClass]="{
                'next-title': i === nowIndex + 1
              }"
              [(ngModel)]="item.text"
              (keydown.enter)="converseFocus(i)"
              (ngModelChange)="createNewTitle(item)"
              (blur)="onFinishInputOneHouse(item)"
              placeholder="{{ 'placeholder.house_name' | translate }}"
            />
          </host-input-with-error>
        </div>
        <div nz-col [nzSpan]="3" class="delete" *ngIf="titleList.length !== 1" (click)="delete(i)">
          <img src="/assets/house/delete_circle.png" />
        </div>
      </div>
    </div>
  </div> -->
  <div class="footer flex flex-row items-center">
    <div class="ml-auto">
      <button nz-button nzSize="large" nzType="primary" class="mr-3" (click)="onSave()">
        {{ "word.confirm" | translate }}
      </button>
      <button nz-button nzSize="large" (click)="onCancel()">
        {{ "word.cancel" | translate }}
      </button>
    </div>
  </div>
</div>
